import { render, staticRenderFns } from "./RateComponent.vue?vue&type=template&id=3b35258e"
import script from "./RateComponent.vue?vue&type=script&lang=js"
export * from "./RateComponent.vue?vue&type=script&lang=js"
import style0 from "./RateComponent.vue?vue&type=style&index=0&id=3b35258e&prod&lang=scss&coped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports